var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHashflow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2354 3.34642C21.2277 3.3409 21.2196 3.33552 21.2113 3.33067L16.4851 0.52414C16.2745 0.398981 16.0121 0.3975 15.8002 0.520103C15.5882 0.642571 15.4566 0.871895 15.4566 1.11858V6.66745L10.9999 9.60573L6.54317 6.66745V1.11858C6.54317 0.871895 6.41157 0.642571 6.19964 0.520103C5.98771 0.3975 5.72517 0.398981 5.51484 0.52414L0.788766 3.33067C0.780507 3.33565 0.772515 3.34077 0.764789 3.34628C0.571111 3.47265 0.452026 3.69188 0.452026 3.92525V16.9331C0.452026 17.1663 0.571111 17.3854 0.764523 17.5118C0.772248 17.5173 0.780374 17.5225 0.788632 17.5275L5.5147 20.3341C5.6194 20.3962 5.73902 20.4292 5.86063 20.4292C5.97945 20.4292 6.09667 20.3977 6.19964 20.3381C6.41157 20.2156 6.54317 19.9863 6.54317 19.7396V14.1907L10.9999 11.2526L15.4566 14.1907V19.7396C15.4566 19.9863 15.5882 20.2156 15.8002 20.3381C15.9033 20.3977 16.0205 20.4292 16.1392 20.4292C16.2607 20.4292 16.3803 20.3964 16.485 20.3341L21.2112 17.5275C21.2194 17.5227 21.2274 17.5174 21.2352 17.5118C21.4287 17.3854 21.5479 17.1663 21.5479 16.9329V3.92525C21.5479 3.69188 21.4288 3.47279 21.2354 3.34642ZM16.8217 5.76765V2.32374L19.57 3.9558L16.8217 5.76765ZM16.8217 13.4437V7.41437L20.1828 5.19851V15.6595L16.8217 13.4437ZM19.57 16.9024L16.8217 18.5344V15.0907L19.57 16.9024ZM15.4568 8.3143V12.5439L12.249 10.4291L15.4568 8.3143ZM9.75099 10.4291L6.54317 12.5439V8.3143L9.75099 10.4291ZM5.1781 7.41437V13.4438L1.8171 15.6597V5.19851L5.1781 7.41437ZM2.42997 3.9558L5.1781 2.32388V5.76765L2.42997 3.9558ZM5.1781 15.0905V18.5343L2.42997 16.9024L5.1781 15.0905Z",
    fill: "url(#paint0_linear_1_1967)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_1967",
    x1: 11,
    y1: 20.4292,
    x2: 1.78714,
    y2: 2.56467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#33D9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.548077,
    stopColor: "#2988F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.817308,
    stopColor: "#33D9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33D9FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHashflow);
export default __webpack_public_path__ + "static/media/hashflow.bfcd677755af13e54760321d62c5ef28.svg";
export { ForwardRef as ReactComponent };